import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import ReportLastDate from '../ReportLastDate/ReportLastDate.js';
import Report5G1h from './components/Report5G1h/Report5G1h.js';
import Report5G16h from './components/Report5G16h/Report5G16h.js';
import Report5G1w from './components/Report5G1w/Report5G1w.js';
import Downloads from '../Downloads';

const Report5G = (props) => {
	const reportsLastDates = useSelector(state => state.reportsReducer.reportsLastDates);

	return (
		<Grid container spacing={2}>
			<Grid item md={12}>
				<ReportLastDate date={reportsLastDates.lastDate5gHuawei} dateEricsson={reportsLastDates.lastDate5gEricsson} />
			</Grid>
			<Grid item md={8}>
				<Report5G1h />
				<Report5G16h />
				<Report5G1w />
			</Grid>
			<Grid item md={4}>
				<Downloads />
			</Grid>
		</Grid>
	);
};

export default Report5G;
